class C_Ships
{
    constructor()
    {
        this.ENEMY_SHIP = 1;
        this.CRATE = 2;
        this.DEBRIS = 3;
        this.ROCK = 4;
        this.POD = 5;
        this.FLARE = 6;
        this.MOTHER_OF_THE_MOONS = 7;
    }
}

export default (new C_Ships);